
<div 
  class="popup-card" 
  [style.background-image]="'url(' + popUp.header_image?.[lang()] + ')'"
> 
  <ci-icon-button 
    class="popup-card__close"
    type="tonal" 
    name="close" 
    scale="1x" 
    (click)="closeModal()"
  ></ci-icon-button>

  @if(popUp?.logo_image?.[lang()]){
      <div class="popup-card__logo">
          <img [src]="popUp.logo_image[lang()]" />
      </div>
  }

  @if(popUp?.title?.[lang()] || popUp?.description?.[lang()]){
    <div class="popup-card__content">
      @if(popUp?.title?.[lang()]){
        <h6 class="ci-heading-h6-bold" [style.color]="popUp?.text_color">
            {{ popUp?.title?.[lang()] }}
        </h6>
      }
      @if(popUp?.description?.[lang()]){
        <p 
          class="ci-paragraph-p1-regular" 
          [style.color]="popUp?.text_color"
          [innerHTML]="popUp.description[lang()]">
        </p>
      }
      <p (click)="openPassportGuide()" class="ci-paragraph-p1-regular how-work">
        {{ '¿Cómo funciona el pasaporte digital?' | translate }}
      </p>
    </div>
  }

  <ci-button
    class="popup-card__button ci-btn-primary-m-filled"
    (click)="handleCtaClick()"
    type="button"
    [aria-label]="(isMobile() ? 'Quiero mi pasaporte' : 'Continúa en tu móvil') | translate"
  >
    @if (isMobile()) {
      {{ popUp?.button_text?.[lang()] ?? ('Quiero mi pasaporte' | translate) }}
    } @else {
      {{ 'Continúa en tu móvil' | translate }}
    }
  </ci-button>
</div>